import { PresentationBundleKind } from '@/types/schema';

import { BundleSaveDescriptor } from '../presentationSave.types';
import { createGeneratedBundleCardDescriptor } from './generatedBundleCardDescriptor';

export const healthcareDirectiveBundleDescriptor: BundleSaveDescriptor =
  createGeneratedBundleCardDescriptor({
    kind: PresentationBundleKind.HealthcareDirectiveBundle,
    field: 'healthcareDirectiveBundleConfiguration',
    read: (bundle) => {
      const config = bundle.healthcareDirectiveBundleConfiguration;
      if (!config) return undefined;
      return {
        id: config.id,
        displayName: config.displayName,
        itemsPerPage: config.itemsPerPage,
        cards: config.healthcareDirectives.map((directive) => ({
          id: directive.id,
          name: directive.grantorName,
          items: directive.items,
        })),
      };
    },
  });
